import { lazy } from "react";

const loaders = {
  Dashboard: () => import("@/pages/Dashboard"),
  Policies: () => import("@/pages/Policies"),
  Customers: () => import("@/pages/Customers"),
  Prospects: () => import("@/pages/Prospects"),
  Groups: () => import("@/pages/Groups"),
  Admin: () => import("@/pages/Admin"),
  Reports: () => import("@/pages/Reports"),
  Archive: () => import("@/pages/Archive"),
  DataEntry: () => import("@/pages/DataEntry"),
  Proforma: () => import("@/pages/Proforma"),
  Ledger: () => import("@/pages/Ledger"),
  Settings: () => import("@/pages/Settings"),
  WhatsApp: () => import("@/pages/WhatsApp"),
  Hakedis: () => import("@/pages/Hakedis"),
  Profile: () => import("@/pages/Profile"),
  Landing: () => import("@/pages/Landing"),
  Legal: () => import("@/pages/Legal"),
  Taslak: () => import("@/pages/Taslak"),
  WalletPublic: () => import("@/pages/WalletPublic"),
  ForgotPassword: () => import("@/pages/ForgotPassword"),
  ResetPassword: () => import("@/pages/ResetPassword"),
};

export const pages = Object.fromEntries(Object.entries(loaders).map(([k, fn]) => [k, lazy(fn)]));

const APP_PAGES = ["Dashboard", "Policies", "Customers", "DataEntry", "Ledger", "Hakedis", "Reports", "Archive", "Prospects", "Groups", "Proforma", "Settings", "WhatsApp", "Profile"];

// Giriş sonrası boşta kalınca diğer sayfaları arka planda indirir; menü geçişleri anında olur.
export const prefetchAppPages = () => {
  const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
  idle(() => APP_PAGES.forEach((k, i) => setTimeout(() => loaders[k]().catch(() => {}), i * 150)));
};
